// utils/buildChartData.js
export function buildChartData({ latestMap, seriesDefs, tenorList }) {
  const rowsByTenor = {};

  Object.values(latestMap).forEach((row) => {
    if (!row.tenor) return;
    if (!tenorList.includes(row.tenor)) return;

    const match = seriesDefs.find((def) =>
      row.security_id?.toLowerCase().startsWith(def.prefix.toLowerCase())
    );
    if (!match) return;

    if (!rowsByTenor[row.tenor]) rowsByTenor[row.tenor] = { tenor: row.tenor };

    let value = row.val;
    if (match.divisor) value = value / match.divisor;
    rowsByTenor[row.tenor][match.key] = Number(value);
  });

  // ✅ only return rows that actually have at least one numeric value
  return tenorList
    .map((tenor) => {
      const row = rowsByTenor[tenor];
      if (!row) return null;
      const hasValue = seriesDefs.some(
        (s) => typeof row[s.key] === "number" && !Number.isNaN(row[s.key])
      );
      return hasValue ? row : null;
    })
    .filter(Boolean);
}
